export default {
  title: 'Studio (V2)',
  description: 'Crea y gestiona el sitio web del restaurante con el nuevo Website Studio.',
  retry: 'Reintentar',
  deleted: 'Proyecto eliminado.',
  errors: {
    load: 'No se pudo cargar el proyecto de Studio (V2).',
    create: 'No se pudo crear el proyecto. Inténtalo de nuevo.',
    delete: 'No se pudo eliminar el proyecto. Inténtalo de nuevo.',
  },
  EmptyState: {
    title: 'Aún no hay ningún proyecto de Studio (V2)',
    description:
      'Crea un proyecto para desarrollar el sitio web en el nuevo Website Studio. Studio (V1) se mantiene como está.',
    description_no_access: 'Un gestor de incorporación puede crear el proyecto para esta marca.',
    create: 'Crear proyecto',
  },
  ProjectCard: {
    unnamed: 'Proyecto sin nombre',
    edit: 'Editar en Studio',
    delete: 'Eliminar',
    open: 'Abrir',
    no_domain: 'Aún sin dominio',
    fields: {
      uuid: 'UUID',
      domain: 'Dominio',
      websites: 'Sitios web',
    },
    delete_confirm: {
      title: '¿Eliminar este proyecto?',
      description: 'Se eliminará el proyecto de Studio (V2) y sus sitios web. Podrás crear uno nuevo más tarde.',
      ok: 'Eliminar',
      cancel: 'Cancelar',
    },
  },
};
